<template>
  <div class="menu">
    {{ data.name }}
  </div>
</template>

<script lang="">

export default {
  // Options / Data
  data () {
    return {}
  },
  props: [ 'data' ]
}
</script>

<style scoped>
.menu {
  position: fixed;
  top: 0;
  left: 0;
  width  : 200px;
  height : 200px;
  background-color: white;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/popup-window/test.vue